module.exports = __webpack_public_path__ + "static/dynamic-machines-316bcec350774914a67f3740add983be.png";